import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9e1b836e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar-body grid no-gutter py-2 text-black20 mx-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "名前", -1))
const _hoisted_3 = { class: "col-9" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "フリガナ", -1))
const _hoisted_5 = { class: "col-9" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "カルテNo.", -1))
const _hoisted_7 = { class: "col-9" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "電話番号", -1))
const _hoisted_9 = { class: "col-9" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "予約日", -1))
const _hoisted_11 = { class: "col-9" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "リクエスト日時", -1))
const _hoisted_13 = { class: "col-9" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "メニュー名", -1))
const _hoisted_15 = { class: "col-9" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "オプションメニュー", -1))
const _hoisted_17 = { class: "col-9" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "金額", -1))
const _hoisted_19 = { class: "col-9" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "指名料", -1))
const _hoisted_21 = { class: "col-9" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "担当施術者", -1))
const _hoisted_23 = { class: "col-9" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "予約メモ", -1))
const _hoisted_25 = { class: "col-9" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "気になる部位・お悩みの症状", -1))
const _hoisted_27 = { class: "col-9 mt-2" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "特記事項", -1))
const _hoisted_29 = {
  class: "col-9 mt-2 overflow-auto",
  style: {"max-height":"30vh"}
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "ステータス", -1))
const _hoisted_31 = { class: "col-9" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "希望日時", -1))
const _hoisted_33 = { class: "col-9" }
const _hoisted_34 = ["for"]

import { withDefaults } from "vue";
import moment from "moment";
import EditableTextareaBooking from "@/clinic/components/atoms/EditableTextareaBooking/index.vue";
import TimeUtils from "@/clinic/utils/time-utils";
import { BookingServices } from "@/clinic/services";
import { ApiBookingShowReq, ApiCommentBookingReq, IBooking } from "@/clinic/typings";
import NumberUtils from "@/clinic/utils/number-utils";
import { ToastServiceMethods } from "primevue/toastservice";
import { ClinicPartner } from "@/clinic/typings/enums/clinic";
import { useStore } from "vuex";

type IBodyShowSidebar = {
  booking: IBooking;
  toast: ToastServiceMethods;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'body',
  props: {
    booking: { default: {} },
    toast: null
  },
  setup(__props: any) {

const props = __props as { booking: IBooking, toast: ToastServiceMethods };

const store = useStore();



const onEditing = async (id: number, comment: string): Promise<void> =>
  await BookingServices.saveComment({ id } as ApiBookingShowReq, { comment } as unknown as ApiCommentBookingReq);

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, _toDisplayString(props.booking?.customer?.name || props.booking?.customer_name), 1),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, _toDisplayString(props.booking?.customer?.name_kana), 1),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, _toDisplayString(props.booking?.customer_id), 1),
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, _toDisplayString(props.booking?.customer?.phone), 1),
      (props.booking?.start_time && props.booking?.end_time)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(TimeUtils).formatRangeDateTime(
            new Date(_unref(TimeUtils).toLocalTime(props.booking?.start_time.toString())),
            new Date(_unref(TimeUtils).toLocalTime(props.booking?.end_time.toString()))
          )), 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, _toDisplayString(props.booking?.created_at
            ? _unref(moment)(_unref(TimeUtils).toLocalTime(props.booking.created_at)).format("YYYY/MM/DD HH:mm:ss")
            : ""), 1)
          ], 64)),
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, _toDisplayString(props.booking?.menu_name), 1),
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.booking.medical_option_names, (option, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "flex align-items-center"
          }, [
            _createElementVNode("div", null, _toDisplayString(option), 1)
          ]))
        }), 128))
      ]),
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(NumberUtils).formatJPCurrency(parseInt(props.booking?.total_amount), "")) + "円", 1),
      _hoisted_20,
      _createElementVNode("div", _hoisted_21, _toDisplayString(props.booking?.additional_fees
          ? _unref(NumberUtils).formatJPCurrency(parseInt(props.booking?.additional_fees["nomination_fee"]), "") + `円`
          : ""), 1),
      _hoisted_22,
      _createElementVNode("div", _hoisted_23, _toDisplayString(props.booking?.staff_name), 1),
      _hoisted_24,
      _createElementVNode("div", _hoisted_25, [
        _createVNode(EditableTextareaBooking, {
          customerId: props.booking?.id,
          comment: `${props.booking?.note || ''}`,
          onClick: onEditing,
          disabled: _unref(store).getters['authClient/selectedClinic'].partner != _unref(ClinicPartner).Unaffiliated
        }, null, 8, ["customerId", "comment", "disabled"])
      ]),
      _hoisted_26,
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("span", null, _toDisplayString(props.booking?.note_symptom), 1)
      ]),
      _hoisted_28,
      _createElementVNode("div", _hoisted_29, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.booking.special_notes, (note, index) => {
          return (_openBlock(), _createElementBlock("p", {
            class: "special-note white-space-normal m-0 mb-2 text-sm",
            key: index
          }, _toDisplayString(index + 1) + ". " + _toDisplayString(note.content), 1))
        }), 128))
      ]),
      _hoisted_30,
      _createElementVNode("div", _hoisted_31, _toDisplayString(props.booking?.status_name), 1),
      (!(props.booking?.start_time && props.booking?.end_time))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.booking?.booking_requests, (request) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "flex align-items-center mb-2 radio-wrapper__custom",
                  key: request.id
                }, [
                  _createElementVNode("label", {
                    for: `request-${request.id}`,
                    class: _normalizeClass(["flex ml-2 align-items-center", { 'text-orange': _ctx.requestId == request.id }])
                  }, " 第" + _toDisplayString(request.priority + 1) + "希望日: " + _toDisplayString(_unref(moment)(_unref(TimeUtils).toLocalTime(request.start_time)).format("YYYY/MM/DD HH:mm")), 11, _hoisted_34)
                ]))
              }), 128))
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Toast, { position: "top-center" })
  ], 64))
}
}

})